import styled from 'styled-components';
import Card from '@bit/wavfichacerta.fichacerta.cards.card';

import backgroundImage from './../../img/png/background-capa3.png'

export const LoginContainer = styled.div`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  box-sizing: border-box;
  background-color: ${props => props.theme['color_light-gray']};
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;

  @media (max-width: 480px) {
    padding: max(1rem, env(safe-area-inset-top, 0px)) 0.85rem 1.25rem;
  }
`;

export const LoginContainerTransparent = styled.div`
  background-color: ${({bgColor}) => bgColor || 'rgba(40, 45, 64, 0.6)'};
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: ${({zIndex}) => zIndex || '1'};
  opacity: ${({opacity}) => opacity || '1'};
  background: linear-gradient(145deg, rgba(12, 22, 42, 0.88) 0%, rgba(20, 43, 78, 0.92) 48%, rgba(10, 18, 36, 0.94) 100%);
`;

export const CardLogin = styled(Card)`
  padding: 0 !important;
  width: 100%;
  max-width: 520px;
  border-radius: 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  background: linear-gradient(168deg, rgba(32, 44, 72, 0.92) 0%, rgba(18, 30, 52, 0.96) 100%) !important;
  box-shadow:
    0 28px 64px rgba(0, 0, 0, 0.42),
    0 0 0 1px rgba(255, 255, 255, 0.04) inset !important;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  overflow: hidden !important;

  .card-body,
  & > div {
    padding: 2rem 2.25rem 2.35rem !important;
    background: transparent !important;
  }

  @media (max-width: 480px) {
    border-radius: 16px !important;

    .card-body,
    & > div {
      padding: 1.35rem 1.1rem 1.6rem !important;
    }
  }
`;

export const LinkExteral = styled.a`
  color: #ff8c38;
  text-decoration: none !important;
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 1.75rem;
  letter-spacing: 0.02em;
  transition: color 0.18s ease, opacity 0.18s ease;

  &:hover {
    color: #ffb366;
    opacity: 0.95;
  }
`;
